import { FormComponentPropsBase, FormExpression } from '@unistocks/components/form/model';
import { arrayify, isFunction } from '@unistocks/shared/utils/util';
import { FieldValues, useWatch } from 'react-hook-form';

export function useExpressionValue<TFieldValues extends FieldValues = FieldValues>(
  expression?: FormExpression,
  dependsOn?: FormComponentPropsBase<TFieldValues>['dependsOn']
) {
  const isDynamic = isFunction(expression);
  const dependentFieldValues = useWatch({
    name: dependsOn ? arrayify(dependsOn) : [],
    disabled: !isDynamic || !dependsOn
  });

  if (isDynamic) {
    return expression(...dependentFieldValues);
  }

  return !!expression;
}
